import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import './styles.css';


const getParagraphVariantDefault = ()=>'standard';

var styles = {
    "paragraph": "Paragraph-module_paragraph__HUxqW",
    "paragraph_standard": "Paragraph-module_paragraph_standard__uih09",
    "paragraph_ingress": "Paragraph-module_paragraph_ingress__GEISx",
    "paragraph_hasSpacingLarge": "Paragraph-module_paragraph_hasSpacingLarge__MiCqI",
    "paragraph_hasSpacingExtraLarge": "Paragraph-module_paragraph_hasSpacingExtraLarge__dA-u2"
};

const Paragraph = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, variant = getParagraphVariantDefault(), canBeManuallyFocused, hasSpacing, children }, ref)=>{
    let spacingClassName = '';
    if (hasSpacing) {
        if (variant === 'standard') {
            spacingClassName = styles.paragraph_hasSpacingLarge;
        } else if (variant === 'ingress') {
            spacingClassName = styles.paragraph_hasSpacingExtraLarge;
        }
    }
    const concatenatedClassName = `${styles.paragraph} ${styles[`paragraph_${variant}`]} ${spacingClassName} ${className}`.trim();
    return /*#__PURE__*/ jsx("p", {
        ref: ref,
        id: id,
        className: concatenatedClassName,
        lang: lang,
        "data-testid": dataTestId,
        tabIndex: canBeManuallyFocused ? -1 : undefined,
        children: children
    });
});
Paragraph.displayName = 'Paragraph';

export { Paragraph, getParagraphVariantDefault };
